/*
 * @Date: 2022-01-07 18:06:15
 * @LastEditors: 西南以北
 * @LastEditTime: 2022-01-12 17:30:57
 * @FilePath: /jiameihui/src/components/Editor/index.js
 */
import React from 'react';
import { Editor } from '@tinymce/tinymce-react';
import PropTypes from 'prop-types';
import { request1, api } from '@/utils';
import { Skeleton } from 'antd';

interface IProps {
  getHtmlData: Record<string, string>;
  setRichText: (text: string) => void;
  form: any;
  onChange: (v: any) => void;
}

class ReactEditor extends React.Component<Partial<IProps>> {
  constructor(props) {
    super(props);
    this.state = {};
    this.handleInit = this.handleInit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(value) {
    this.setState({ text: value });
    this.props.setRichText?.(value);
    this.props.form.setFieldsValue({
      content: value,
    });
  }

  handleInit() {
    this.timeoutClearId = setTimeout(
      () => {
        this.setState((prev) => ({
          ...prev,
          isInit: true,
        }))
      },
      1 * 1000,
    )
  }

  componentWillReceiveProps(props) {
    this.setState({
      text: props.getHtmlData,
    });
  }

  componentWillUnmount = () => {
    this.timeoutClearId &&
      clearTimeout(this.timeoutClearId);

    this.setState = (state, callback) => { };
  };

  render() {
    const texts = this.state.text || '';

    return (
      <div
        style={
          !this.state.isInit ?
            {
              position: "relative",
              minHeight: 500,
            } :
            {}
        }
      >
        {this.state.isInit ? null : <Skeleton active loading style={{ zIndex: 99999, position: 'absolute', }} />}

        <div
          style={{
            display: this.state.isInit ? "block" : "none"
          }}
        >
          <Editor
            value={texts}
            onEditorChange={this.handleChange}
            // apiKey="6dehmqrnpxyrdrurllrqvfv28jl89e01ezxtubdma40cilml"
            tinymceScriptSrc="/tinymce/tinymce.min.js"
            init={{
              language: 'zh_CN',
              width: this.props.width,
              min_height: this.props.height || 667,
              plugins:
                'preview searchreplace autolink directionality visualblocks visualchars fullscreen image link template code codesample table charmap hr pagebreak nonbreaking anchor insertdatetime advlist lists wordcount imagetools textpattern help emoticons autosave autoresize ',
              toolbar:
                'code undo redo restoredraft | cut copy paste pastetext | forecolor backcolor bold italic underline strikethrough link anchor | alignleft aligncenter alignright alignjustify outdent indent | styleselect formatselect fontselect fontsizeselect | bullist numlist | blockquote subscript superscript removeformat | table image media charmap emoticons hr pagebreak insertdatetime print preview | fullscreen | bdmap indent2em lineheight  axupimgs',
              fontsize_formats: '12px 14px 16px 18px 24px 36px 48px 56px 72px',
              // images_upload_url: api.smallUploadFile,
              images_upload_handler: (blobInfo, success, failure) => {
                const formData = new FormData();
                formData.append('file', blobInfo.blob());
                // 调接口，上传图片
                request1(api.smallUploadFile, {
                  login: true,
                  method: 'POST',
                  body: formData,
                  data: formData,
                  headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                  },
                }).then((res) => {
                  if (res.status === 200) {
                    const httpUrl = sessionStorage.getItem('httpUrl');
                    success(`${httpUrl}/${res.data}`);
                  }
                });
                // const img = `data:image/jpeg;base64,${blobInfo.base64()}`
                // success(img)
              },
              file_picker_callback(callback, value, meta) {
                const input = document.createElement('input');
                let filetype =
                  '.pdf, .txt, .zip, .rar, .7z, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .mp3, .mp4';
                // 后端接收上传文件的地址
                // 为不同插件指定文件类型及后端地址
                switch (meta.filetype) {
                  case 'image':
                    filetype = '.jpg, .jpeg, .png, .gif';
                    break;
                  case 'media':
                    filetype = '.mp3, .mp4';
                    break;
                  case 'file':
                  default:
                }
                input.setAttribute('type', 'file');
                input.setAttribute('accept', filetype);
                input.click();
                input.onchange = function () {
                  const file = this.files[0];
                  const formData = new FormData();
                  formData.append('file', file, file.name);
                  request1(api.smallUploadFile, {
                    login: true,
                    method: 'POST',
                    body: formData,
                    data: formData,
                    headers: {
                      'Content-Type': 'application/x-www-form-urlencoded',
                    },
                  }).then((res) => {
                    if (res.status === 200) {
                      const httpUrl = sessionStorage.getItem('httpUrl');
                      callback(`${httpUrl}/${res.data}`, { alt: file.name });
                    }
                  });
                };
              },
            }}
            onInit={this.handleInit}
          // id="tincyEditor"
          />
        </div>
      </div>
    )
  }
}

ReactEditor.propTypes = {
  dispatch: PropTypes.func,
  types: PropTypes.string,
  getHtmlData: PropTypes.string,
};

export default ReactEditor;
